import isDocument from './isDocument';
import isWindow from './isWindow';
/**
 * Get the current vertical position of the scroll bar for the specified
 * element.
 *
 * The vertical scroll position is the same as the number of pixels
 * that are hidden from view to the top of the scrollable area. If the
 * scroll bar is at the very top, or if the element is not scrollable,
 * this number will be `0`.
 *
 * Note: Does not work if the element it is being applied to is hidden.
 */

export default function getScrollTop(element) {
  if (isWindow(element)) {
    return element.pageYOffset;
  }

  if (isDocument(element)) {
    return element.defaultView != null ? element.defaultView.pageYOffset : 0;
  }

  return element.scrollTop;
}
//# sourceMappingURL=getScrollTop.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/fraud/~/@flowio/browser-helpers/dist/esm/getScrollTop.js
// module id = 308
// module chunks = 0 1